import { render, staticRenderFns } from "./TrashboxPage.vue?vue&type=template&id=3d8ef310&scoped=true&"
import script from "./TrashboxPage.vue?vue&type=script&lang=js&"
export * from "./TrashboxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ef310",
  null
  
)

export default component.exports